/* Phase 12 (X-01) serious/critical axe fixes that need runtime DOM patching
   rather than editing Minimog core files (theme-global.js, gallery.liquid)
   or SABERA's own hero-slideshow markup.

   1) aria-hidden-focus: any aria-hidden="true" element (collapsible-tab
      FAQ/footer accordions, inactive hero-slideshow slides, etc.) can still
      leave an <a>/<button> inside it natively tabbable. Mirror the
      aria-hidden state onto tabindex for every such element sitewide,
      generically, rather than hardcoding each known component.
   2) scrollable-region-focusable: horizontally-scrollable galleries need to be
      reachable by keyboard, not just touch/drag. */
(function () {
  function syncAriaHiddenFocus(el) {
    var hidden = el.getAttribute('aria-hidden') === 'true';
    var focusable = el.querySelectorAll('a[href], button, input, select, textarea, [tabindex]');
    focusable.forEach(function (child) {
      if (hidden) {
        if (!child.hasAttribute('data-sabera-prev-tabindex')) {
          child.setAttribute('data-sabera-prev-tabindex', child.getAttribute('tabindex') || '');
        }
        child.setAttribute('tabindex', '-1');
      } else if (child.hasAttribute('data-sabera-prev-tabindex')) {
        var prev = child.getAttribute('data-sabera-prev-tabindex');
        if (prev) child.setAttribute('tabindex', prev);
        else child.removeAttribute('tabindex');
        child.removeAttribute('data-sabera-prev-tabindex');
      }
    });
  }

  var watched = new WeakSet();
  function watchAriaHidden(el) {
    if (watched.has(el)) return;
    watched.add(el);
    syncAriaHiddenFocus(el);
    new MutationObserver(function () { syncAriaHiddenFocus(el); })
      .observe(el, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function initAriaHiddenFocusGuards() {
    document.querySelectorAll('[aria-hidden]').forEach(watchAriaHidden);
  }

  // Catch aria-hidden elements added after initial load (slideshow re-renders,
  // quick-view modal, infinite scroll) without re-scanning the whole document.
  function initAriaHiddenMutationWatcher() {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes && m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.hasAttribute && node.hasAttribute('aria-hidden')) watchAriaHidden(node);
          if (node.querySelectorAll) node.querySelectorAll('[aria-hidden]').forEach(watchAriaHidden);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function initScrollableGalleryFocus() {
    document.querySelectorAll('.m-gallery').forEach(function (gallery) {
      var overflowX = getComputedStyle(gallery).overflowX;
      var scrollable = gallery.scrollWidth > gallery.clientWidth && (overflowX === 'auto' || overflowX === 'scroll');
      if (scrollable && !gallery.hasAttribute('tabindex')) {
        gallery.setAttribute('tabindex', '0');
        if (!gallery.hasAttribute('role')) gallery.setAttribute('role', 'region');
        if (!gallery.hasAttribute('aria-label')) gallery.setAttribute('aria-label', 'Image gallery, scrollable');
      }
    });
  }

  // X-07: wishlist.js (Minimog core) toggles a visual "added-to-wishlist" class
  // on click but never updates aria-label/aria-pressed, so a screen-reader user
  // hears "Add to wishlist" both before and after adding it — no state is
  // announced at all.
  function syncWishlistAria(btn) {
    var added = btn.classList.contains('added-to-wishlist');
    btn.setAttribute('aria-pressed', added ? 'true' : 'false');
    btn.setAttribute('aria-label', added ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function initWishlistAriaSync() {
    document.querySelectorAll('.m-wishlist-button').forEach(function (btn) {
      syncWishlistAria(btn);
      new MutationObserver(function () { syncWishlistAria(btn); })
        .observe(btn, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function init() {
    initAriaHiddenFocusGuards();
    initAriaHiddenMutationWatcher();
    initScrollableGalleryFocus();
    initWishlistAriaSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // New collapsible-tab / gallery instances can appear after quick-view opens,
  // infinite-scroll loads more products, etc. — re-scan on Minimog's own event bus.
  window.addEventListener('load', function () { setTimeout(init, 500); });
})();
